// extracted by mini-css-extract-plugin
export default {"main":"main_main__GjSzl","title":"main_title__PglUT","subtitle":"main_subtitle__OiexO","list":"main_list__jhyBR"};